import { TriangleAlert } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { usePendingFeeTableReadings } from '../../api/fee-tables';
import { usePendingPolicies } from '../../api/policies';

/**
 * Aviso fixo do painel da plataforma: mudança de política de tarifa esperando revisão. Fica em
 * todas as páginas até alguém revisar — enquanto isso, a margem de todas as empresas segue a
 * versão anterior da tarifa (ADR-030, ADR-077).
 */
export function PendingPoliciesBanner() {
  const pending = usePendingPolicies();
  const readings = usePendingFeeTableReadings();
  const count = pending.data?.pending ?? 0;
  const tables = readings.data?.pending ?? 0;
  if (count === 0 && tables === 0) return null;
  return (
    <div className="space-y-2 px-4 pt-4">
      {tables > 0 && (
        <Alert variant="warning">
          <TriangleAlert aria-hidden />
          <AlertTitle>
            {tables === 1
              ? 'Tabela de tarifa lida esperando sua decisão'
              : `${tables} tabelas de tarifa lidas esperando sua decisão`}
          </AlertTitle>
          <AlertDescription className="flex flex-wrap items-center justify-between gap-2">
            <span>
              A leitura automática achou mudança (ou não conseguiu fechar a tabela). Até você
              decidir, a margem de todas as empresas segue a tabela vigente.
            </span>
            <Button asChild size="sm" variant="warning">
              <Link to="/plataforma/politicas">Conferir agora</Link>
            </Button>
          </AlertDescription>
        </Alert>
      )}
      {count > 0 && (
        <Alert variant="warning">
          <TriangleAlert aria-hidden />
          <AlertTitle>
            {count === 1
              ? '1 mudança de política de tarifa para revisar'
              : `${count} mudanças de política de tarifa para revisar`}
          </AlertTitle>
          <AlertDescription className="flex flex-wrap items-center justify-between gap-2">
            <span>
              Uma plataforma mudou a página oficial de tarifas. Enquanto não for revisada, a margem
              de todas as empresas segue a versão anterior.
            </span>
            <Button asChild size="sm" variant="warning">
              <Link to="/plataforma/politicas">Revisar agora</Link>
            </Button>
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}
